module.exports = __webpack_public_path__ + "static/media/snowflake.5978a590.svg";